import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { Moment } from 'moment';

interface ICookieOptions {
  SameSite?: 'None' | 'Lax' | 'Strict';
  Secure?: boolean;
  Path?: string;
  Domain?: string;
  Expires?: string;
  'Max-Age'?: number;
}

@Injectable({ providedIn: 'root' })
export class CookieService {
  private readonly defaultOptions: ICookieOptions;

  public constructor(@Inject(DOCUMENT) private readonly document: Document) {
    this.defaultOptions =
      document.location.hostname === 'localhost'
        ? {
            SameSite: 'Lax',
            Path: '/',
          }
        : {
            SameSite: 'None',
            Secure: true,
            Path: '/',
          };
  }

  public getCookie(cookieName: string): string | null {
    const cookieArray = this.parseCookie(this.document.cookie);
    const name = `${cookieName}=`;

    for (const item of cookieArray) {
      if (item.indexOf(name) === 0) {
        return item.substring(name.length, item.length);
      }
    }

    return null;
  }

  public setCookie(cookieName: string, cookieValue: string, expirationDate: Moment, options?: ICookieOptions): void {
    if (!options) {
      options = {};
    }

    if (cookieValue) {
      if (expirationDate) {
        options.Expires = expirationDate.toDate().toUTCString();
      }
    } else {
      options['Max-Age'] = 0;
    }

    this.document.cookie = `${cookieName}=${cookieValue ? encodeURIComponent(cookieValue) : ''}; ${this.getOptionsString(options)}`;
  }

  protected parseCookie(cookie: string): string[] {
    const decodedCookie = decodeURIComponent(cookie);
    const cookieArray = decodedCookie.split(';');
    const res = [];

    for (const item of cookieArray) {
      let curr = item;
      while (curr.charAt(0) === ' ') {
        curr = curr.substring(1);
      }

      res.push(curr);
    }

    return res;
  }

  private getOptionsString(options: ICookieOptions): string {
    options = options ? { ...this.defaultOptions, ...options } : this.defaultOptions;

    return Object.keys(options)
      .map((key) => {
        const value = options[key];

        let cookieString = key;
        if (value !== undefined) {
          cookieString += `=${value}`;
        }

        return cookieString;
      })
      .join('; ');
  }
}
